import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Tag } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtDate } from "../../../lib/format";
import { mediaUrl, trackPromo } from "../promoTrack";

const Card = ({ p }) => {
  const { t, lang } = useI18n();
  const pick = (f) => p[`${f}_${lang}`] || p[`${f}_el`];
  useEffect(() => { trackPromo(p.id, "view"); }, [p.id]);
  return (
    <Link to={`/app/promotions/${p.id}`} data-testid={`promo-${p.id}`}
      className="group relative flex w-[85%] shrink-0 snap-start flex-col overflow-hidden rounded-2xl bg-navy text-white sm:w-[440px]">
      {p.image_url ? (
        <img src={mediaUrl(p.image_url)} alt={pick("title")} className="h-36 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      ) : <div className="h-2 bg-brand" />}
      <div className="flex flex-1 flex-col p-4">
        <span className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wider text-brand"><Tag className="h-3 w-3" /> {t("promo.badge")} · {t("promo.until", { date: fmtDate(p.end_date) })}</span>
        <p className="mt-1 text-lg font-bold leading-tight">{pick("title")}</p>
        {pick("text") && <p className="mt-1 line-clamp-2 text-sm text-white/80">{pick("text")}</p>}
        <ArrowRight className="mt-auto h-5 w-5 self-end pt-1 text-brand transition-transform duration-200 group-hover:translate-x-1" />
      </div>
    </Link>
  );
};

export const PromoBanner = ({ promos }) => {
  if (!promos?.length) return null;
  return (
    <div className="-mx-4 flex snap-x snap-mandatory scroll-px-4 gap-3 overflow-x-auto px-4 pb-1 [scrollbar-width:none]" data-testid="promo-banner">
      {promos.map((p) => <Card key={p.id} p={p} />)}
    </div>
  );
};
